module.exports = __webpack_public_path__ + "static/img/maintenance-inactive.30d4455.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/maintenance-inactive.svg
// module id = LW5M
// module chunks = 262